
export { default as Chat2FillIcon } from "./Chat2Fill.js"
export { default as Chat2Icon } from "./Chat2.js"